/**
 * Role-aware permission utilities (mirrors backend ROLE_PERMISSIONS).
 */
export const ROLE_PERMISSIONS = {
  super_admin: ["orders.view","orders.create","orders.manage","payments.confirm","production.update","releasing.update","expenses.manage","supplies.manage","supplies.view","analytics.view","users.manage","services.manage","services.view","pricing.manage","customers.manage","customers.view"],
  front_office: ["orders.view","orders.create","services.view","analytics.view","customers.manage"],
  cashier: ["orders.view","payments.confirm","analytics.view","customers.view"],
  production: ["orders.view","production.update","supplies.view"],
  releasing: ["orders.view","releasing.update"],
  accounting: ["expenses.manage","supplies.manage","supplies.view","analytics.view","orders.view","customers.manage"],
  customer: [],
};

export const ADMIN_ROLES = ["front_office","cashier","production","releasing","accounting","super_admin"];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  front_office: "Front Office",
  cashier: "Cashier",
  production: "Production",
  releasing: "Releasing",
  accounting: "Accounting",
  customer: "Customer",
};

export const hasPerm = (user, perm) => {
  if (!user) return false;
  const perms = user.permissions || ROLE_PERMISSIONS[user.role] || [];
  return perms.includes(perm);
};

export const isAdmin = (user) => user && ADMIN_ROLES.includes(user.role);
